var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Button, CircularFrame, ContentFrame, DotLoader, Icon, LayoutContent, LayoutControls, LinkButton, SearchInput, Typography, } from '@pinwheel/origami';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import CompanyIcon from '../../components/CompanyIcon';
import SearchProviderButton from '../../components/SearchProviderButton';
import { useOpts } from '../../context';
import { useAppDispatch } from '../../state';
import { hubApi } from '../../state/services/hub-api';
import { updateInitializationContext } from '../../state/slices/slice-link-api';
import { useScrolledViewSx } from '../../utils/useScrolledViewSx';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { getLoadWorkdayEmployersFn } from '../../utils';
import { WORKDAY_ID_PROD, WORKDAY_ID_STAG, } from '../../views/SearchLegacy/FilterSearch';
import useGetActionOnClick from './Action/utils';
function TemplateSearch(_a) {
    var _this = this;
    var submitStep = _a.submitStep, linkApiResponse = _a.linkApiResponse;
    // Flag to ensure lock after initial click (no duplicate Link API reqs)
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var _c = useState(false), isScrolled = _c[0], setIsScrolled = _c[1];
    var scrolledViewSx = useScrolledViewSx({ isScrolled: isScrolled });
    var opts = useOpts();
    var linkTokenPayload = opts.linkTokenPayload, linkToken = opts.linkToken;
    var mode = linkTokenPayload.mode;
    var getLocalizedString = useGetLocalizedString();
    var dispatch = useAppDispatch();
    var searchInputRef = useRef(null);
    var onClick = useCallback(function (result) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (clicked)
                        return [2 /*return*/];
                    setClicked(true);
                    return [4 /*yield*/, dispatch(updateInitializationContext(result.responseType === 'platform'
                            ? {
                                platformId: result.id,
                            }
                            : {
                                employerId: result.id,
                            }))];
                case 1:
                    _a.sent();
                    submitStep({
                        id: result.id,
                        responseType: result.responseType,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [clicked, dispatch, submitStep]);
    var _d = useState(''), searchText = _d[0], setSearchText = _d[1];
    var _e = hubApi.useLazySearchQuery(), triggerSearch = _e[0], _f = _e[1], searchResults = _f.data, isLoading = _f.isFetching, isSuccess = _f.isSuccess;
    /*
     * This is a very jank solution to be able to search for workday "tagged"
     * employers on the TemplateSearch search screen.
     *
     * We needed to get this up and running in a short period of time,
     * whoever needs to maintain this, I'm sorry.
     */
    var parentEntityId = linkApiResponse.template.queryParams.parentEntityId;
    var isWorkday = parentEntityId &&
        (parentEntityId === WORKDAY_ID_PROD || parentEntityId === WORKDAY_ID_STAG);
    var _g = useState(false), isWorkdayLoading = _g[0], setIsWorkdayLoading = _g[1];
    var _h = useState(null), workdayResults = _h[0], setWorkdayResults = _h[1];
    useEffect(function () {
        if (isWorkday && searchText) {
            setIsWorkdayLoading(true);
            void getLoadWorkdayEmployersFn(mode, linkToken)(searchText).then(function (results) {
                setWorkdayResults(results);
                setIsWorkdayLoading(false);
            });
        }
        else {
            void triggerSearch({
                searchText: searchText,
                queryParams: linkApiResponse.template.queryParams,
                fromTemplateSearch: true,
            });
        }
    }, [triggerSearch, searchText, linkApiResponse, isWorkday, mode, linkToken]);
    var _j = linkApiResponse.template.actions, firstAction = _j[0], _secondAction = _j[1];
    var secondAction = _secondAction !== null && _secondAction !== void 0 ? _secondAction : firstAction; // backwards compatible, in case second action is not available via link-api
    var onClickFirstAction = useGetActionOnClick(firstAction, submitStep);
    var onClickSecondAction = useGetActionOnClick(secondAction, submitStep);
    return (React.createElement(ContentFrame, null,
        React.createElement(LayoutContent, null,
            React.createElement(Box, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }, "data-testid": "TemplateSearch", onSubmit: function (e) { return e.preventDefault(); }, onScroll: function (e) {
                    return !isScrolled && e.currentTarget.scrollTop > 0 && setIsScrolled(true);
                }, sx: scrolledViewSx },
                React.createElement(Box, null,
                    React.createElement(Box, { sx: { padding: '16px 0' } },
                        React.createElement(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            } },
                            React.createElement(CircularFrame, { loading: false, size: "lg", backgroundColorInner: {
                                    type: 'theme',
                                    colorLegacy: 'Neutral/50',
                                    colorNext: 'neutral/default',
                                    opacityNext: 0.7,
                                } },
                                React.createElement(Icon, { icon: "building", size: 48, color: {
                                        type: 'theme',
                                        colorLegacy: 'Neutral/0',
                                        colorNext: 'background/default',
                                    } })),
                            React.createElement(Icon, { sx: { margin: '16px' }, icon: "connector" }),
                            React.createElement(CompanyIcon, { size: "lg", result: opts.selectedEmployer
                                    ? opts.selectedEmployer
                                    : opts.loadedPlatform })),
                        React.createElement(Box, null,
                            React.createElement(Typography, { sx: {
                                    marginTop: '8px',
                                    marginBottom: '8px',
                                }, variant: "header", align: "center", color: "title" }, linkApiResponse.template.title),
                            React.createElement(Typography, { variant: "caption", color: "default", align: "center" },
                                linkApiResponse.template.subtitle,
                                React.createElement(LinkButton, { onClick: onClickFirstAction }, firstAction.label)))),
                    React.createElement(Box, { sx: { marginTop: '24px' } },
                        React.createElement(SearchInput, { value: searchText, ref: searchInputRef, onChange: function (value) {
                                setSearchText(value);
                            }, placeholder: getLocalizedString('SEARCH_BY_NAME') })),
                    React.createElement(Box, { sx: { margin: '24px 0' } },
                        (isLoading || isWorkdayLoading) && (React.createElement("div", { style: {
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                            } },
                            React.createElement(DotLoader, null))),
                        // Show searchResults when isSuccess && !isLoading
                        // AND also when isWorkday is true and searchText is empty
                        isSuccess &&
                            !isLoading &&
                            (!isWorkday || (isWorkday && !searchText)) &&
                            searchResults.map(function (searchResult, i) { return (React.createElement(SearchProviderButton, { key: "".concat(searchResult.id), "data-testid": "provider".concat(i), provider: searchResult, defaultIcon: "building", eventId: "providerSelected-".concat(searchResult.id || ''), onClick: onClick })); }),
                        // Show workdayResults when workdayResults exist && !isWorkdayLoading && isWorkday is true
                        // AND searchText is not empty
                        workdayResults &&
                            !isWorkdayLoading &&
                            isWorkday &&
                            searchText &&
                            workdayResults.map(function (result, i) { return (React.createElement(SearchProviderButton, { key: "".concat(result.id), "data-testid": "provider".concat(i), provider: result, defaultIcon: "building", eventId: "providerSelected-".concat(result.id || ''), onClick: onClick })); }))),
                React.createElement(LayoutControls, { sx: { marginTop: '8px' } }, !searchText ? (
                // TODO: this is duplicated in a few places and should be turned
                //       into a reusable component.
                React.createElement(React.Fragment, null,
                    React.createElement(Typography, { sx: {
                            marginBottom: '8px',
                        }, color: "default", variant: "caption", align: "center" }, getLocalizedString('DONT_SEE_EMPLOYER')),
                    React.createElement(Button, { key: "searchRedirect", variant: "ghost", color: "neutral", "data-testid": "searchRedirect", type: "button", onClick: function () {
                            var _a;
                            (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        } },
                        React.createElement(Typography, { variant: "label", color: {
                                type: 'theme',
                                colorLegacy: 'Blue/50',
                                colorNext: 'brand/default',
                            } }, getLocalizedString('TRY_SEARCHING'))))) : (React.createElement("div", null,
                    React.createElement(Typography, { color: "light", align: "center", variant: "caption" }, linkApiResponse.template.footer),
                    React.createElement(LinkButton, { "data-testid": "searchGenericPlatform", onClick: onClickSecondAction },
                        React.createElement(Typography, { color: "light", align: "center", variant: "caption" }, secondAction.label)))))))));
}
export default TemplateSearch;
